import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';

import { UltraNavigationItem } from '../../shared/models/ultra-navigation-item.model';
import { FEATURES } from '../features/features';

export const MENU_NAVIGATION_DATA: UltraNavigationItem[] = [
	{
		id: 'administration',
		title: 'administration|title',
		type: 'aside',
		icon: 'all_inbox',
		children: [
			...(FEATURES.vehicles
				? [
						{
							id: 'fleet.vehicles',
							title: 'vehicles|title',
							type: 'basic',
							icon: 'directions_car',
							link: 'vehicles',
							module: ModulesEnum.VEHICLES,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.locations
				? [
						{
							id: 'administration.locations',
							title: 'locations|title',
							type: 'basic',
							icon: 'pin_drop',
							link: 'locations',
							module: ModulesEnum.LOCATIONS,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.staff
				? [
						{
							id: 'administration.staff',
							title: 'staff|title',
							type: 'basic',
							icon: 'perm_contact_calendar',
							link: 'staff',
							module: ModulesEnum.STAFF,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.customers
				? [
						{
							id: 'administration.customers',
							title: 'customers|title',
							type: 'basic',
							icon: 'groups',
							link: 'customers',
							module: ModulesEnum.CUSTOMERS,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.suppliers
				? [
						{
							id: 'administration.suppliers',
							title: 'suppliers|title',
							type: 'basic',
							icon: 'business_center',
							link: 'suppliers',
							module: ModulesEnum.SUPPLIERS,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.agents
				? [
						{
							id: 'administration.agents',
							title: 'agents|title',
							type: 'basic',
							icon: 'record_voice_over',
							link: 'agents',
							module: ModulesEnum.AGENTS,
						} as UltraNavigationItem,
					]
				: []),
		],
	},
	{
		id: 'operations',
		title: 'operations|title',
		type: 'aside',
		icon: 'sync_alt',
		children: [
			...(FEATURES.rentalAgreements
				? [
						{
							id: 'operations.rental-agreements',
							title: 'rental-agreements|title',
							type: 'basic',
							icon: 'receipt_long',
							link: 'rental-agreements',
							module: ModulesEnum.RENTAL_AGREEMENTS,
						} as UltraNavigationItem,
					]
				: []),

			...(FEATURES.rentalReservations
				? [
						{
							id: 'operations.rental-reservations',
							title: 'rental-reservations|title',
							type: 'basic',
							icon: 'queue',
							link: 'rental-reservations',
							module: ModulesEnum.RENTAL_RESERVATIONS,
						} as UltraNavigationItem,
					]
				: []),

			...(FEATURES.vehicleMaintenances
				? [
						{
							id: 'fleet.vehicle-maintenances',
							title: 'maintenances|title',
							type: 'basic',
							icon: 'car_repair',
							link: 'vehicle-maintenances',
							module: ModulesEnum.VEHICLE_MAINTENANCES,
						} as UltraNavigationItem,
					]
				: []),
		],
	},
	{
		id: 'documents',
		title: 'documents|title',
		type: 'aside',
		icon: 'article',
		children: [
			...(FEATURES.vehicleRoadTaxes
				? [
						{
							id: 'fleet.vehicle-road-taxes',
							title: 'road-taxes|title',
							type: 'basic',
							icon: 'account_balance',
							link: 'vehicle-road-taxes',
							module: ModulesEnum.VEHICLE_ROAD_TAXES,
							disabled: false,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.vehicleRoadWorthyChecks
				? [
						{
							id: 'fleet.vehicle-road-worthy-checks',
							title: 'road-worthy-checks|title',
							type: 'basic',
							icon: 'inventory',
							link: 'vehicle-road-worthy-checks',
							module: ModulesEnum.VEHICLE_ROAD_WORTHY_CHECKS,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.vehicleInsurances
				? [
						{
							id: 'fleet.vehicle-insurances',
							title: 'vehicle-insurances|title',
							type: 'basic',
							icon: 'gavel',
							link: 'vehicle-insurances',
							module: ModulesEnum.VEHICLE_INSURANCES,
						} as UltraNavigationItem,
					]
				: []),
			...(FEATURES.vehicleDamages
				? [
						{
							id: 'fleet.vehicle-damages',
							title: 'damages|title',
							type: 'basic',
							icon: 'flash_on',
							link: 'vehicle-damages',
							module: ModulesEnum.VEHICLE_DAMAGES,
						} as UltraNavigationItem,
					]
				: []),
		],
	},
	{
		id: 'financials',
		title: 'financials|title',
		type: 'aside',
		icon: 'payments',
		children: [
			...(FEATURES.transactions
				? [
						{
							id: 'financials.transactions',
							title: 'transactions|title',
							type: 'basic',
							icon: 'payment',
							link: 'transactions',
							module: ModulesEnum.TRANSACTIONS,
						} as UltraNavigationItem,
					]
				: []),
		],
	},
	// {
	// 	id: 'integrations',
	// 	title: 'Integrations',
	// 	tooltip: 'Integrations',
	// 	type: 'aside',
	// 	icon: 'settings_ethernet',
	// 	children: [
	// 		{
	// 			id: 'integrations.api-keys',
	// 			title: 'API Keys',
	// 			type: 'basic',
	// 			icon: 'vpn_key',
	// 			link: 'api-keys',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'integrations.webhooks',
	// 			title: 'Webhooks',
	// 			type: 'basic',
	// 			icon: 'cast_connected',
	// 			link: 'webhooks',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'integrations.hub',
	// 			title: 'Integrations Hub',
	// 			type: 'basic',
	// 			icon: 'settings_input_hdmi',
	// 			link: 'integrations-hub',
	// 			disabled: true,
	// 		},
	// 		{
	// 			type: 'divider',
	// 		},
	// 		{
	// 			id: 'integrations.data-import',
	// 			title: 'Data Import',
	// 			type: 'basic',
	// 			icon: 'cloud_upload',
	// 			link: 'integrations-data-import',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'integrations.data-export',
	// 			title: 'Data Export',
	// 			type: 'basic',
	// 			icon: 'cloud_download',
	// 			link: 'integrations-data-export',
	// 			disabled: true,
	// 		},
	// 	],
	// },
	// {
	// 	id: 'reports',
	// 	title: 'Reports',
	// 	tooltip: 'Reports',
	// 	type: 'aside',
	// 	icon: 'insert_chart_outlined',
	// 	children: [
	// 		{
	// 			id: 'reports.administration-reports',
	// 			title: 'Administration Reports',
	// 			type: 'basic',
	// 			icon: 'all_inbox',
	// 			link: 'administration-reports',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'reports.fleet-reports',
	// 			title: 'Fleet Reports',
	// 			type: 'basic',
	// 			icon: 'directions_boat',
	// 			link: 'fleet-reports',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'reports.operations-reports',
	// 			title: 'Operations Reports',
	// 			type: 'basic',
	// 			icon: 'work_outline',
	// 			link: 'operations-reports',
	// 			disabled: true,
	// 		},
	// 		{
	// 			type: 'divider',
	// 		},
	// 		{
	// 			id: 'reports.usage-audit-logs',
	// 			title: 'Usage & Audit Logs',
	// 			type: 'basic',
	// 			icon: 'history',
	// 			link: 'usage-audit-logs',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'reports.account-billing-reports',
	// 			title: 'Account & Billing Reports',
	// 			type: 'basic',
	// 			icon: 'account_balance_wallet',
	// 			link: 'account-billing-reports',
	// 			disabled: true,
	// 		},
	// 		{
	// 			type: 'divider',
	// 		},
	// 		{
	// 			id: 'reports.integrations-reports',
	// 			title: 'Integrations Reports',
	// 			type: 'basic',
	// 			icon: 'settings_ethernet',
	// 			link: 'integrations-reports',
	// 			disabled: true,
	// 		},
	// 	],
	// },
	// {
	// 	id: 'platform',
	// 	title: 'Platform',
	// 	tooltip: 'Platform',
	// 	type: 'aside',
	// 	icon: 'cloud',
	// 	children: [
	// 		{
	// 			id: 'platform.help-center',
	// 			title: 'Help Center',
	// 			type: 'basic',
	// 			icon: 'support_agent',
	// 			link: 'support',
	// 			disabled: true,
	// 		},
	// 		{
	// 			type: 'divider',
	// 		},
	// 		{
	// 			id: 'platform.privacy-policy',
	// 			title: 'Privacy Policy',
	// 			type: 'basic',
	// 			icon: 'privacy_tip',
	// 			link: 'privacy-policy',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'platform.terms-of-service',
	// 			title: 'Terms of Service',
	// 			type: 'basic',
	// 			icon: 'description',
	// 			link: 'terms-of-service',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'platform.licenses',
	// 			title: 'Licenses',
	// 			type: 'basic',
	// 			icon: 'verified',
	// 			link: 'licenses',
	// 			disabled: true,
	// 		},
	// 		{
	// 			type: 'divider',
	// 		},
	// 		{
	// 			id: 'platform.release-notes',
	// 			title: 'Release Notes',
	// 			type: 'basic',
	// 			icon: 'rss_feed',
	// 			link: 'release-notes',
	// 			disabled: true,
	// 		},
	// 		{
	// 			id: 'platform.about',
	// 			title: 'About',
	// 			type: 'basic',
	// 			icon: 'info',
	// 			link: 'about',
	// 			disabled: true,
	// 		},
	// 	],
	// },
];
